<div [class.app-shell]="data" [class.app-shell--collapsed]="data && sidebarState.collapsed">
  <app-header *ngIf="data"></app-header>
  <div class="app-main">
    <app-loader></app-loader>
    <div class="main-content bg-light">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
